import {Injectable} from '@angular/core';
import {TagModel} from "../model/tag.model";
import {TagSummaryModel} from "../model/tagSummary.model";
import {AbstractFindAllService} from "../../../../core/service/v2/service/findAll/abstractFindAll.service";
import {TagRepository} from "../../impl/service/ngrx/tag.repository";
import {TagSummaryDataServiceAdapter} from "../../impl/service/ngrx/tagSummaryDataService.adapter";
import {AbstractFindOneByIdService} from "../../../../core/service/v2/service/findone/abstractFindOneById.service";
import {TagDataServiceAdapter} from "../../impl/service/ngrx/tagDataService.adapter";

@Injectable()
export class TagFindOneService extends AbstractFindOneByIdService<TagModel, TagModel> {
    constructor(repository: TagRepository, dataService: TagDataServiceAdapter) {
        super(repository, dataService);
    }
}
